import { render } from "./Exception.vue?vue&type=template&id=07487482"
const script = {}

import exportComponent from "/Users/jeff/projects/js/pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__